<template>
    <div>
        <!-- 面包屑组件 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>上课记录</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 内容卡片 -->
        <el-card>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="课节明细" name="1">
                    <!-- 查询框 -->
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-select v-model="queryInfo1.courseId" placeholder="请选择课程">
                                <el-option
                                    v-for="item in courseList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo1.teacherId" placeholder="请选择老师">
                                <el-option key="" value="">{{'全部老师'}}</el-option>
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                          <el-input
                            v-model="queryInfo1.studentName"
                            placeholder="请输入学员姓名/手机号"
                            clearable
                          >
                          </el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo1.classId" placeholder="请选择班级">
                                <el-option key="" value="">{{'全部班级'}}</el-option>
                                <el-option
                                    v-for="item in classList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo1.timeType" placeholder="请选择时间">
                                <el-option
                                    v-for="item in queryTimeList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-button @click="handleSearch(1)" type="primary">搜索</el-button>
                            <el-button @click="handleExport(1)" type="success">导出</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList1"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="班级名称" prop="className"></el-table-column>
                        <el-table-column label="课程名称"  prop="courseName"></el-table-column>
                        <el-table-column label="消课次数"  prop="deductTimes"></el-table-column>
                        <el-table-column label="老师姓名"  prop="teacherName"></el-table-column>
                        <el-table-column label="上课教室"  prop="classRoom"></el-table-column>
                        <el-table-column label="上课时间" width="190" prop="classDateStr"></el-table-column>
<!--                        <el-table-column label="应到人数"  prop="totalNum"></el-table-column>-->
                        <el-table-column label="签到/缺勤/补课">
                          <template slot-scope="scope">
                            <span>{{scope.row.signNum}}</span> /
                            <span>{{scope.row.absenceNum}}</span> /
                            <span>{{scope.row.remedialTeachingNum}}</span>
                          </template>
                        </el-table-column>
                    </el-table>

                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo1.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo1.pageSize"
                        :total="queryInfo1.total"
                        background
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="消课明细" name="2">
                     <!-- 查询框 -->
                    <el-row :gutter="24">
                        <el-col :span="4">
                          <el-select v-model="queryInfo2.courseId" placeholder="请选择课程">
                            <el-option key="" value="">{{'全部课程'}}</el-option>
                            <el-option
                              v-for="item in courseList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo2.teacherId" placeholder="请选择老师">
                                <el-option key="" value="">{{'全部老师'}}</el-option>
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                          <el-input
                            v-model="queryInfo2.studentName"
                            placeholder="请输入学员姓名/手机号"
                            clearable
                          >
                          </el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo2.classId" placeholder="请选择班级">
                                <el-option key="" value="">{{'全部班级'}}</el-option>
                                <el-option
                                    v-for="item in classList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo2.timeType" placeholder="请选择时间">
                                <el-option
                                    v-for="item in queryTimeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-button @click="handleSearch(2)" type="primary">搜索</el-button>
                            <el-button @click="handleExport(2)" type="success">导出</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList2"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="学员姓名" prop="studentName"></el-table-column>
                        <el-table-column label="学员手机号"  prop="studentPhone"></el-table-column>
                        <el-table-column label="班级名称"  prop="className"></el-table-column>
                        <el-table-column label="课程名称"  prop="courseName"></el-table-column>
                        <el-table-column label="课程套餐名称"  prop="setMealName"></el-table-column>
                        <el-table-column label="上课老师"  prop="teacherName"></el-table-column>
                        <el-table-column label="上课时间"  prop="classDateStr"></el-table-column>
                        <el-table-column label="消课时间"  prop="deductTimeStr"></el-table-column>
                        <el-table-column label="限次消课次数"  prop="deductTimes"></el-table-column>
                        <el-table-column label="限时消课天数"  prop="deductDays"></el-table-column>
                    </el-table>

                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo2.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo2.pageSize"
                        :total="queryInfo2.total"
                        background
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="上课明细" name="3">
                    <!-- 查询框 -->
                     <el-row :gutter="24">
                        <el-col :span="4">
                            <el-select v-model="queryInfo3.courseId" placeholder="请选择课程">
                                <el-option key="" value="">{{'全部课程'}}</el-option>
                                <el-option
                                v-for="item in courseList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="3">
                            <el-select v-model="queryInfo3.teacherId" placeholder="请选择老师">
                                <el-option key="" value="">{{'全部老师'}}</el-option>
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                       <el-col :span="3">
                         <el-input
                           v-model="queryInfo3.studentName"
                           placeholder="学员姓名/手机号"
                           clearable
                         >
                         </el-input>
                       </el-col>
                        <el-col :span="3">
                            <el-select v-model="queryInfo3.classId" placeholder="请选择班级">
                                <el-option key="" value="">{{'全部班级'}}</el-option>
                                <el-option
                                    v-for="item in classList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo3.timeType" placeholder="请选择时间">
                                <el-option
                                    v-for="item in queryTimeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                         <el-col :span="3">
                            <el-select v-model="queryInfo3.isSign" placeholder="请选择状态">
                                <!-- 是否签到：0未签到，1已签到，2已缺勤 -->
                                <el-option
                                    :key="''"
                                    label="全部"
                                    :value="''">
                                </el-option>
                                <el-option
                                    :key="0"
                                    label="未签到"
                                    :value="0">
                                </el-option>
                                <el-option
                                    :key="1"
                                    label="已签到"
                                    :value="1">
                                </el-option>
                                <el-option
                                    :key="2"
                                    label="已缺勤"
                                    :value="2">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-button @click="handleSearch(3)" type="primary">搜索</el-button>
                            <el-button @click="handleExport(3)" type="success">导出</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList3"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="学员姓名" prop="studentName"></el-table-column>
                        <el-table-column label="手机号码"  prop="studentPhone"></el-table-column>
                        <el-table-column label="班级名称"  prop="className"></el-table-column>
                        <el-table-column label="课程名称"  prop="courseName"></el-table-column>
                        <el-table-column label="上课教室"  prop="classRoom"></el-table-column>
                        <el-table-column label="上课时间"  prop="classDateStr"></el-table-column>
                        <el-table-column label="上课老师"  prop="teacherName"></el-table-column>
                        <el-table-column label="学员状态"  prop="status"></el-table-column>
                        <el-table-column label="操作"  prop="statusStr"></el-table-column>
                    </el-table>
                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo3.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo3.pageSize"
                        :total="queryInfo3.total"
                        background
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="补课明细" name="4">
                    <!-- 查询框 -->
                     <el-row :gutter="24">
                        <el-col :span="4">
                            <el-select v-model="queryInfo4.courseId" placeholder="请选择课程">
                                <el-option
                                v-for="item in courseList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo4.teacherId" placeholder="请选择老师">
                                <el-option key="" value="">{{'全部老师'}}</el-option>
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                         <el-col :span="4">
                           <el-input
                             v-model="queryInfo4.studentName"
                             placeholder="请输入学员姓名/手机号"
                             clearable
                           >
                           </el-input>
                         </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo4.classId" placeholder="请选择班级">
                                <el-option key="" value="">{{'全部班级'}}</el-option>
                                <el-option
                                    v-for="item in classList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo4.timeType" placeholder="请选择时间">
                                <el-option
                                    v-for="item in queryTimeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-button @click="handleSearch(4)" type="primary">搜索</el-button>
                            <el-button @click="handleExport(4)" type="success">导出</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList4"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="学员姓名" prop="studentName"></el-table-column>
                        <el-table-column label="手机号"  prop="studentPhone"></el-table-column>
                        <el-table-column label="班级名称"  prop="className"></el-table-column>
                        <el-table-column label="课程名称"  prop="courseName"></el-table-column>
                        <el-table-column label="上课教室"  prop="classRoom"></el-table-column>
                        <el-table-column label="上课时间"  prop="classDateStr"></el-table-column>
                        <el-table-column label="补课时间"  prop="makeUpLessonDateStr"></el-table-column>
                        <el-table-column label="操作人"  prop="operator"></el-table-column>
                        <el-table-column label="备注"  prop=""></el-table-column>
                    </el-table>

                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo4.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo4.pageSize"
                        :total="queryInfo4.total"
                        background
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="薪酬明细" name="5">
                    <!-- 查询框 -->
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-select v-model="queryInfo5.courseId" placeholder="请选择课程">
                                <el-option
                                v-for="item in courseList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo5.teacherId" placeholder="请选择老师">
                                <el-option key="" value="">{{'全部老师'}}</el-option>
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo5.classId" placeholder="请选择班级">
                                <el-option key="" value="">{{'全部班级'}}</el-option>
                                <el-option
                                    v-for="item in classList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo5.timeType" placeholder="请选择时间">
                                <el-option
                                    v-for="item in queryTimeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-button @click="handleSearch(5)" type="primary">搜索</el-button>
                            <el-button @click="handleExport(5)" type="success">导出</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList5"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="老师姓名" prop="teacherName"></el-table-column>
                        <el-table-column label="班级名称"  prop="className"></el-table-column>
                        <el-table-column label="课程名称"  prop="courseName"></el-table-column>
                        <el-table-column label="上课时间"  prop="classDateStr"></el-table-column>
                        <el-table-column label="消课时间"  prop="deductTimes"></el-table-column>
                        <el-table-column label="点名学管"  prop=""></el-table-column>
                        <el-table-column label="签到学员人数"  prop="signNum"></el-table-column>
                        <el-table-column label="薪酬第一人基数"  prop=""></el-table-column>
                        <el-table-column label="薪酬累计基数"  prop=""></el-table-column>
                        <el-table-column label="合计薪酬"  prop=""></el-table-column>
                    </el-table>

                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo5.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo5.pageSize"
                        :total="queryInfo5.total"
                        background
                    ></el-pagination>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                activeName:'1',
                dataList1: [],
                dataList2: [],
                dataList3: [],
                dataList4: [],
                dataList5: [],
                // 排序方式(1价格升序、2价格降序、3次数升序、4次数降序，5新增时间升序，6新增时间降序（默认）
                queryInfo1: {
                    studentName:'',
                    courseId:'',
                    teacherId: '',
                    classId: '',
                    timeType: '',
                    signIn:'',
                    sort:'',
                    pageSize: 10,
                    pageNo: 1,
                },
                queryInfo2: {
                    studentName:'',
                    courseId:'',
                    teacherId: '',
                    classId: '',
                    timeType: '',
                    signIn:'',
                    sort:'',
                    pageSize: 10,
                    pageNo: 1,
                    total:0
                },
                queryInfo3: {
                    studentName:'',
                    courseId:'',
                    teacherId: '',
                    classId: '',
                    timeType: '',
                    signIn:'',
                    sort:'',
                    pageSize: 10,
                    pageNo: 1,
                    total:0
                },
                queryInfo4: {
                    studentName:'',
                    courseId:'',
                    teacherId: '',
                    classId: '',
                    timeType: '',
                    signIn:'',
                    sort:'',
                    pageSize: 10,
                    pageNo: 1,
                    total:0
                },
                queryInfo5: {
                    studentName:'',
                    courseId:'',
                    teacherId: '',
                    classId: '',
                    timeType: '',
                    signIn:'',
                    sort:'',
                    pageSize: 10,
                    pageNo: 1,
                    total:0
                },
                queryInfo: {
                    name:'',
                    courseId:'',
                    teacherId: '',
                    classId: '',
                    timeType: '',
                    signIn:'',
                    sort:'',
                    pageSize: 10,
                    pageNo: 1,
                    total:0
                },
                courseList: [
                    { id: '', name: '全部课程'}
                ],
                teacherList: [],
                classList:[
                    { id:1, name:'1对1' },
                    { id:2, name:'班课' },
                ],
                queryTimeList: [
                    { label:'最近七天',value: 3},
                    { label:'今天', value: 1},
                    { label:'昨天', value: 2},
                    { label:'本月',value: 4},
                    { label:'上月',value: 5}
                ],
                signInList:[
                    { id: '', name: '全部'},
                    { id: 1, name: '已签到'},
                    { id: 2, name: '未签到'}
                ],
                sortList:[
                    { id: 1, name: '消课时间'},
                    { id: 2, name: '课程名称'},
                    { id: 3, name: '班级名称'}
                ],
                monthList:[
                    { label:'2020年11月份',value: 11},
                    { label:'2020年10月份',value: 10},
                    { label:'2020年09月份',value: 9},
                    { label:'2020年08月份',value: 8},
                    { label:'2020年07月份',value: 7},
                    { label:'2020年06月份',value: 6},
                    { label:'2020年05月份',value: 5},
                    { label:'2020年04月份',value: 4},
                    { label:'2020年03月份',value: 3},
                    { label:'2020年02月份',value: 2},
                    { label:'2020年01月份',value: 1}
                ],
                total: 0,
                selectList: [],
                fromData:{
                    id:'',
                    title:'',
                    teacherId:'',
                    month:''
                },
                editData:{}
            }
        },
        mounted() {
            this.initData(1);
            this.getTeacherList();
            this.getCourseList();
        },
        methods:{

            async initData(tabNum) {
                if(this.queryInfo.time){
                    this.queryInfo.beginTime=this.queryInfo.time[0];
                    this.queryInfo.endTime=this.queryInfo.time[1];
                    delete this.queryInfo.time;
                }else {
                    delete this.queryInfo.time;
                }
                if(tabNum == 1){ // 课节明细
                    await this.$http.post("/ea/student/classStudentRecord/classDetailList",this.queryInfo1).then((res) => {
                        let data = res.data;
                        if(data && (data.code == 0 || data.code == 200)){
                            this.dataList1 = data.result.records;
                            this.queryInfo1.total = data.result.total;
                        }else {
                            this.$message({
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }else if(tabNum == 2){// 消课明细
                    await this.$http.post("/ea/student/classStudentRecord/expendDetailList",this.queryInfo2).then((res) => {
                        let data = res.data;
                        if(data && (data.code == 0 || data.code == 200)){
                            this.dataList2 = data.result.records;
                            this.queryInfo2.total = data.result.total;
                        }else {
                            this.$message({
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }else if(tabNum == 3){// 上课明细
                    await this.$http.post("/ea/student/classStudentRecord/attendClassDetailList",this.queryInfo3).then((res) => {
                        let data = res.data;
                        if(data && (data.code == 0 || data.code == 200)){
                            this.dataList3 = data.result.records;
                            this.queryInfo3.total = data.result.total;
                        }else {
                            this.$message({
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }else if(tabNum == 4){// 补课明细
                    await this.$http.post("/ea/student/classStudentRecord/makeUpLessonsDetailList",this.queryInfo4).then((res) => {
                        let data = res.data;
                        if(data && (data.code == 0 || data.code == 200)){
                            this.dataList4 = data.result.records;
                            this.queryInfo4.total = data.result.total;
                        }else {
                            this.$message({
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }else if(tabNum == 5){// 薪酬明细
                    await this.$http.post("/ea/student/classStudentRecord/salaryDetailList",this.queryInfo5).then((res) => {
                        let data = res.data;
                        if(data && (data.code == 0 || data.code == 200)){
                            this.dataList5 = data.result.records;
                            this.queryInfo5.total = data.result.total;
                        }else {
                            this.$message({
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }
            },
            handleExport(tabNum){
                if(tabNum == 1){ // 课节明细
                    let url = '/ea/student/classStudentRecord/exportXls'
                    this.fetchDownloadProgress(url,this.queryInfo1,'课节明细');
                }else if(tabNum == 2){// 消课明细
                    let url = '/ea/student/classStudentRecord/expendDetailExportXls'
                    this.fetchDownloadProgress(url,this.queryInfo2,'消课明细');
                }else if(tabNum == 3){// 上课明细
                    let url = '/ea/student/classStudentRecord/attendClassDetailExportXls'
                    this.fetchDownloadProgress(url,this.queryInfo3,'上课明细');
                }else if(tabNum == 4){// 补课明细
                    let url = '/ea/student/classStudentRecord/makeUpLessonsDetailExportXls'
                    this.fetchDownloadProgress(url,this.queryInfo4,'补课明细');
                }else if(tabNum == 5){// 薪酬明细
                    let url = '/ea/student/classStudentRecord/salaryDetailExportXls'
                    this.fetchDownloadProgress(url,this.queryInfo5,'薪酬明细');
                }
            },
            fetchDownloadProgress(url,searchData,fileName) {
                this.$http({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: searchData
                })
                .then(res => {
                    var blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
                    var downloadElement = document.createElement('a');
                    var href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = '导出文件.xls'; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                    // const BLOB = res.data;
                    // const fileReader = new FileReader();
                    // fileReader.readAsDataURL(BLOB);
                    // fileReader.onload = e => {
                    //     let a = document.createElement("a");
                    //     a.download = fileName + ".xlsx";
                    //     a.href = e.target.result;
                    //     document.body.appendChild(a);
                    //     a.click();
                    //     document.body.removeChild(a);
                    // };
                })
                .catch(err => {
                    console.log(err.message);
                });
            },
            // 获取所有授课老师
            async getTeacherList() {
                this.courseList = [];
                const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherList`);
                if (res.code !== 200)
                return this.$message.error(res.message);
                this.teacherList = res.result;
            },
            async getCourseList() {
                this.courseList = [];
                const { data: res } = await this.$http.get(`/ea/student/course/getCourseList`);
                if (res.code !== 200)
                return this.$message.error(res.message);
                let list  = res.result.courses;
                list.map(e=>{
                    let item = {
                        id:e.id,
                        name:e.name
                    }
                    this.courseList.push(item);
                })
            },
            handleSearch(num) {
                this.initData(num);
            },
            handleSetRules() {
                this.$router.push('/setRules');
            },
            // 选择tab切换
            handleClick(tab, event) {
                this.initData(tab.name);
            },
            // 获取上课时间
            getTime(time){
            },
            handleClear(num) {
                if(num == 1){
                    this.queryInfo1 = {
                        courseId:'',
                        teacherId: '',
                        classId: '',
                        timeType: '',
                        signIn:'',
                        sort:'',
                        pageSize: 10,
                        pageNo: 1,
                    }
                }else if(num == 2) {
                    this.queryInfo2 = {
                        studentName:'',
                        courseId:'',
                        teacherId: '',
                        classId: '',
                        timeType: '',
                        signIn:'',
                        sort:'',
                        pageSize: 10,
                        pageNo: 1
                    }
                }else if(num == 3) {
                    this.queryInfo3 = {
                        studentName:'',
                        courseId:'',
                        teacherId: '',
                        classId: '',
                        timeType: '',
                        signIn:'',
                        sort:'',
                        pageSize: 10,
                        pageNo: 1
                    }
                }else if(num == 4) {
                    this.queryInfo4 = {
                        studentName:'',
                        courseId:'',
                        teacherId: '',
                        classId: '',
                        timeType: '',
                        signIn:'',
                        sort:'',
                        pageSize: 10,
                        pageNo: 1,
                    }
                }else if(num == 5) {
                    this.queryInfo5 = {
                        studentName:'',
                        courseId:'',
                        teacherId: '',
                        classId: '',
                        timeType: '',
                        signIn:'',
                        sort:'',
                        pageSize: 10,
                        pageNo: 1,
                    }
                }
            },
            handleSelectionChange(val) {
                this.selectList = val;
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
        }
    }
</script>

<style lang="less" scoped>
    .tips {
        color: #666666;
        font-size: 12px;
        margin-left: 22px;
        .icons {
            font-size: 14px;
            color: #666666;
        }
    }
</style>
